module.exports = __webpack_public_path__ + "media/images/icons/office-building-a21a7768fa3b5dcf41a6fd6106d93ec0.svg";